import { Contact } from './contact.types';

export const adaptContactFromServer = (contact: Contact): Contact => {
  return {
    ...contact,
    name: contact.fullname || contact.name,
    fullname: contact.fullname || contact.name
  };
};

export const adaptContactListFromServer = (contacts: Contact[]): Contact[] => {
  return (contacts || []).map(adaptContactFromServer);
};
